import React from 'react';
import { Link } from 'react-router-dom';
import techImage from '../img/tech1.jpg';

const HealthcareAIPage = () => {
  const features = [
    {
      title: "AI-Powered Diagnostics",
      description: "Enhance accuracy and efficiency in radiology and pathology with cutting-edge machine learning tools.",
      icon: "🔬"
    },
    {
      title: "Intelligent Patient Advisory",
      description: "Provide personalized patient guidance and support through AI-driven advisory services.",
      icon: "👥"
    },
    {
      title: "Workflow Optimization",
      description: "Streamline healthcare processes and improve operational efficiency with AI automation.",
      icon: "⚡"
    },
    {
      title: "Precision Medicine",
      description: "Leverage AI for more accurate diagnoses and personalized treatment plans.",
      icon: "🎯"
    }
  ];

  return (
    <div className="min-h-screen bg-figma-dark-bg-primary text-figma-dark-text-primary">
      {/* Hero Section */}
      <section 
        className="relative min-h-[60vh] bg-cover bg-center flex items-center justify-center"
        style={{ backgroundImage: `url(${techImage})` }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="relative z-10 text-center px-4 py-16">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6">
            <span className="bg-gradient-to-r from-figma-dark-primary to-figma-dark-accent bg-clip-text text-transparent">
              Transforming Healthcare with AI
            </span>
          </h1>
          <p className="text-xl text-figma-dark-text-secondary max-w-3xl mx-auto">
            Elevate your screening and diagnostic capabilities with our AI-enabled solutions
          </p>
        </div>
      </section>

      {/* Description Section */}
      <section className="py-16 px-4 max-w-4xl mx-auto text-center">
        <p className="text-lg text-figma-dark-text-secondary leading-relaxed">
          Elevate the capabilities of your screening and diagnostic centers with our AI-enabled solutions. 
          By integrating cutting-edge machine learning tools, we enhance accuracy and efficiency in radiology 
          and pathology, while also providing intelligent patient advisory services. Improve diagnostic precision, 
          streamline workflows, and deliver superior patient care with our innovative healthcare AI.
        </p>
      </section>

      {/* Features Grid */}
      <section className="py-20 px-4 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-figma-dark-bg-secondary/30 backdrop-blur-sm border border-figma-dark-border rounded-xl p-6 hover:shadow-figma-dark-glow transition-all duration-300"
            >
              <div className="text-4xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold mb-3 text-white">{feature.title}</h3>
              <p className="text-figma-dark-text-secondary">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 bg-figma-dark-bg-secondary/20">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6 text-white">Ready to Transform Your Healthcare Services?</h2>
          <p className="text-figma-dark-text-secondary mb-8">
            Let's discuss how our AI solutions can enhance your diagnostic capabilities
          </p>
          <Link
            to="/contact"
            className="px-8 py-4 rounded-full bg-gradient-to-r from-figma-dark-primary to-figma-dark-accent text-white font-medium hover:shadow-figma-dark-glow transition-all duration-300 hover:scale-105"
          >
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HealthcareAIPage; 